import React from 'react';
import PropTypes from 'prop-types';

import {
	Row,
	Col,
	AverageRating,
	AvgExplain,
	AvgContainer,
	WriteReviewContainer,
	ReviewsLink,
} from './reviewsStyles';

import RatingStars from 'core/components/RatingStars';
import Bar from './Bar';
import { WriteReviewButton } from 'listing/components';

const Breakdown = ({
	slug,
	totalReviews,
	averageRating,
	fiveStars,
	fourStars,
	threeStars,
	twoStars,
	oneStar,
	handleWriteReviewClick,
	mostRecentReview,
}) => (
	<Row>
		<Col>
			<ReviewsLink href={`/subscription-box/${slug}/reviews/`} title="See all reviews">
				<AvgContainer>
					<AverageRating>{(Math.round(averageRating * 10) / 10)}</AverageRating>
					<AvgExplain>Average Subscriber Rating</AvgExplain>
				</AvgContainer>
				<RatingStars
					slug={slug}
					stars={averageRating}
					reviews={totalReviews}
					starsOnly
				/>
			</ReviewsLink>
			<WriteReviewContainer>
				<WriteReviewButton
					size="md"
					themeType="antistroke"
					className="writeReviewBtn"
					slug={slug}
					onClick={handleWriteReviewClick}>
					{mostRecentReview  ? 'Edit Your Review' : 'Write a Review'}
				</WriteReviewButton>
			</WriteReviewContainer>
		</Col>

		<Col large>
			<Bar stars={5} percentage={fiveStars} slug={slug} />
			<Bar stars={4} percentage={fourStars} slug={slug} />
			<Bar stars={3} percentage={threeStars} slug={slug} />
			<Bar stars={2} percentage={twoStars} slug={slug} />
			<Bar stars={1} percentage={oneStar} slug={slug} />
		</Col>
	</Row>
);


Breakdown.propTypes = {
	slug: PropTypes.string.isRequired,
	totalReviews: PropTypes.number,
	averageRating: PropTypes.number,
	fiveStars: PropTypes.number,
	fourStars: PropTypes.number,
	threeStars: PropTypes.number,
	twoStars: PropTypes.number,
	oneStar: PropTypes.number,
	showStars: PropTypes.bool,
	handleWriteReviewClick: PropTypes.func,
	mostRecentReview: PropTypes.shape({
		id: PropTypes.number.isRequired,
		title: PropTypes.string,
		body: PropTypes.string.isRequired,
		rating: PropTypes.number.isRequired,
		images: PropTypes.array.isRequired,
		createdAt: PropTypes.string.isRequired,
		shipping: PropTypes.number,
		quality: PropTypes.number,
		curation: PropTypes.number,
	}),
};

Breakdown.defaultProps = {
	slug: PropTypes.string.isRequired,
	totalReviews: 0,
	averageRating: 0.0,
	fiveStars: 0,
	fourStars: 0,
	threeStars: 0,
	twoStars: 0,
	oneStar: 0,
	showStars: false,
};

export default Breakdown;
